import React, { useState, useEffect } from 'react'
import { getSupplierInfoAPi, logOutApi } from '../../Api/BarestSupplierServices'
import BottomNavigation from '../../Components/BottomNavigation/BottomNavigation'
import Performancepoints from '../../Components/PerformancePoints/Performancepoints'
import SalesRepoart from '../../Components/salesRepoart/SalesRepoart'
import { useHistory } from 'react-router';
import Style from './Dashboard.module.css'
const Dashboard = () => {
    const[checkTable,setCheckTable]=useState(false)
    // const[supplierInfo,setSupplierInfo]=useState([])
    // console.log(path.split('/')[2])
    let history= useHistory()
    useEffect(()=>{
        // const path = window.location.pathname
        // localStorage.setItem("type",path.split('/')[2])
        // localStorage.setItem("supplierToken",path.split('/')[3])
        // setTimeout(() => {
        //     window.location='/'
        // }, 1000);
        getSupplierInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    const LogoutHandler=()=>{
        let info={
            logout:""
        }
        logOutApi(info,succ=>{
            console.log(succ)
        })
    }
    //////////// get supplier info /////////////
    const getSupplierInfo=async()=>{ 
        const result =await getSupplierInfoAPi()
        if(localStorage.getItem("supplierToken")){
            if(result.status===-2){
                LogoutHandler()
                localStorage.clear()
                history.push("/login")
                setTimeout(() => {
                    window.location.reload()
                }, 100);
            }
            else if (result.info.lat==="" && result.info.lon===""){
                setTimeout(() => {
                    history.push('/selectaddress')
                },0);
            }
        }
    }
    return (
        <div className={Style.PageHolder}>
            <section className={Style.tabHolder}>
                <div className={checkTable?null:Style.onFocus} onClick={()=>setCheckTable(false)}>گزارش فروش</div>
                <div className={checkTable?Style.onFocus:null} onClick={()=>setCheckTable(true)}> امتیاز عملکرد</div>
            </section>
            {
                checkTable?<Performancepoints/>:<SalesRepoart/>
            }
            <BottomNavigation/>
        </div>
    )
}

export default Dashboard
